// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1eWEp","content":"styles_content__2RuxX","checkbox":"styles_checkbox__7t0Ho","checkboxLabel":"styles_checkboxLabel__1FRgg"};